import { render, staticRenderFns } from "./HomeViewPersonCtrol.vue?vue&type=template&id=105e19a7&scoped=true&"
import script from "./HomeViewPersonCtrol.vue?vue&type=script&lang=js&"
export * from "./HomeViewPersonCtrol.vue?vue&type=script&lang=js&"
import style0 from "./HomeViewPersonCtrol.vue?vue&type=style&index=0&id=105e19a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e19a7",
  null
  
)

export default component.exports